export enum TRACKING_ID {
  GoogleTagManagerWeb = 'GTM-TPDNKZHK',
}

export const TRACKING_LIBS = {
  GoogleTagManager: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://sgtm.perpetua.io/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${TRACKING_ID.GoogleTagManagerWeb}');`,
};

export const BOTS = [
  'datadogsynthetics',
  'googlebot',
  'headlesschrome',
  'bingbot',
  'slurp',
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'exabot',
  'facebot',
  'ia_achiver',
];

export enum DL_EVENT {
  elementClick = 'isElementClicked',
  formSubmit = 'isFormSubmitted',
  formSubmitError = 'isFormNotSubmitted',
}

export enum LABEL {
  BI = 'BI',
  AMC = 'AMC',
  Demo = 'Demo',
  Signin = 'Sign In',
  Signup = 'Get Started',
  Learn = 'Learn More',
  Prism = 'Prism',
  Webinar = 'Webinar',
  Affiliate = 'Affiliate',
  Newsletter = 'Newsletter',
  Benchmarker = 'Benchmarker',
  Downloadable = 'Downloadable',
  Chat = 'Chat With Us',
  Startup = 'Startup',
}

export enum FORM_TYPE {
  SignUp = 'Sign Up',
  WEBINAR = 'Webinar',
  RESOURCE = 'Resource',
  AFFILIATE = 'Affiliate', 
  DATA_CONSULT = 'Data Consult',
  PRISM = 'Prism',
}

export enum PAGE_SLOT {
  Hero = 'Hero',
  Midpage = 'Mid-page',
  Footer = 'Footer',
  Sidebar = 'Sidebar',
  Navi = 'Navigation',
}

export enum UTM {
  campaign = 'utm_campaign',
  medium = 'utm_medium',
  source = 'utm_source',
  term = 'utm_term',
  content = 'utm_content',
  id = 'utm_id'
}

export enum platformID {
  gclid = 'gclid',
  fbclid = 'fbclid',
  li_fat_id = 'li_fat_id',
  campaignid = 'campaignid',
  adgroupid = 'adgroupid',
  keyword = 'keyword',
}
